define("shared/components/shared/linkinbio/modal/shopify-product-selector", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@ember/service", "@glimmer/component", "@ember/utils", "@glimmer/tracking", "ember-concurrency-decorators", "ember-concurrency"], function (_exports, _component, _templateFactory, _object, _service, _component2, _utils, _tracking, _emberConcurrencyDecorators, _emberConcurrency) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;

  0; //eaimeta@70e063a35619d71f0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@ember/utils",0,"@glimmer/tracking",0,"ember-concurrency-decorators",0,"ember-concurrency",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div
    class="o--modalCard--secondary"
    {{did-insert this.loadProducts}}
  >
    <div class="o--modalHeader u--p__tb__md">
      <p class="o--modalHeader__title">
        {{t "shopify.modal_secondary.title"}}
      </p>
      <p class="u--p__t__xs">
        {{t "shopify.modal_secondary.subtitle"}}
      </p>
    </div>
    <section
      class="o--modalBody--secondary u--p__0 u--m__t__lg u--p__b__lg"
      {{perfect-scroll}}
    >
      <form class="o--formWrapper  u--p__lr__lg u--m__b search-bar">
        <div class="o--inputAction">
          <span class="o--inputAction__icon--left">
            {{svg-jar "search" class="o--icon"}}
          </span>
          <Input
            @type="text"
            @value={{this.shopifyQuery}}
            @key-up={{perform this.searchProducts this.shopifyQuery}}
            class="o--inputAction__input"
            @id="exampleInput"
            placeholder={{t "shared_words.search"}}
            @preventDefault={{true}}
            @disabled={{this.isLoading}}
          />
          <span {{did-insert this.clearQuery}}>
            {{svg-jar "close" class="o--icon o--inputAction__icon--right u--fadeIn--right"}}
          </span>
        </div>
      </form>
      {{#if this.searchProducts.isRunning}}
        <Shared::LoadingSpinner/>
        {{!-- <p class="u--p__lg">{{t "shopify.modal_secondary.searching"}}</p> --}}
      {{else if this.isLoading}}
        <Shared::LoadingSpinner/>
      {{else if this.noSearchResults}}
        <p class="u--p__lg">
          {{t "shopify.modal_secondary.no_results" query=this.shopifyQuery}}
        </p>
      {{else if this.noProducts}}
        <div class="o--blank">
          <h2 class="o--blank__title">
            {{t "shopify.errors.no_products.title"}}
          </h2>
          <p class="o--blank__desc u--text--light">
            {{html-safe (t "shopify.errors.no_products.description") }}
          </p>
        </div>
      {{else}}
        <ul class="u--listUnstyle">
          {{#if this.showSearchResults}}
            {{#each this.searchResults as |product|}}
              <Shared::Linkinbio::Item::ShopifyProduct
                @product={{product}}
                @setProduct={{@setProduct}}
              />
            {{/each}}
          {{else}}
            {{#each this.filteredShopifyProducts as |product|}}
              <Shared::Linkinbio::Item::ShopifyProduct
                @product={{product}}
                @setProduct={{@setProduct}}
              />
            {{/each}}
          {{/if}}
          {{#if this.canLoadMore}}
            <p 
              class="u--text--center u--text--light u--p__t"
              {{in-viewport onEnter=(action this.loadMore) viewportSpy=true}}
            >
              {{t "shared_words.loading"}}
            </p>
          {{/if}}
        </ul>
      {{/if}}
    </section>
  </div>
  */
  {
    "id": "lvX9GMlr",
    "block": "[[[11,0],[24,0,\"o--modalCard--secondary\"],[4,[38,0],[[30,0,[\"loadProducts\"]]],null],[12],[1,\"\\n  \"],[10,0],[14,0,\"o--modalHeader u--p__tb__md\"],[12],[1,\"\\n    \"],[10,2],[14,0,\"o--modalHeader__title\"],[12],[1,\"\\n      \"],[1,[28,[35,1],[\"shopify.modal_secondary.title\"],null]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,2],[14,0,\"u--p__t__xs\"],[12],[1,\"\\n      \"],[1,[28,[35,1],[\"shopify.modal_secondary.subtitle\"],null]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[11,\"section\"],[24,0,\"o--modalBody--secondary u--p__0 u--m__t__lg u--p__b__lg\"],[4,[38,2],null,null],[12],[1,\"\\n    \"],[10,\"form\"],[14,0,\"o--formWrapper  u--p__lr__lg u--m__b search-bar\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"o--inputAction\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"o--inputAction__icon--left\"],[12],[1,\"\\n          \"],[1,[28,[35,3],[\"search\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[8,[39,4],[[24,0,\"o--inputAction__input\"],[16,\"placeholder\",[28,[37,1],[\"shared_words.search\"],null]]],[[\"@type\",\"@value\",\"@key-up\",\"@id\",\"@preventDefault\",\"@disabled\"],[\"text\",[30,0,[\"shopifyQuery\"]],[28,[37,5],[[30,0,[\"searchProducts\"]],[30,0,[\"shopifyQuery\"]]],null],\"exampleInput\",true,[30,0,[\"isLoading\"]]]],null],[1,\"\\n        \"],[11,1],[4,[38,0],[[30,0,[\"clearQuery\"]]],null],[12],[1,\"\\n          \"],[1,[28,[35,3],[\"close\"],[[\"class\"],[\"o--icon o--inputAction__icon--right u--fadeIn--right\"]]]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"],[41,[30,0,[\"searchProducts\",\"isRunning\"]],[[[1,\"      \"],[8,[39,7],null,null,null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"isLoading\"]],[[[1,\"      \"],[8,[39,7],null,null,null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"noSearchResults\"]],[[[1,\"      \"],[10,2],[14,0,\"u--p__lg\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"shopify.modal_secondary.no_results\"],[[\"query\"],[[30,0,[\"shopifyQuery\"]]]]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"noProducts\"]],[[[1,\"      \"],[10,0],[14,0,\"o--blank\"],[12],[1,\"\\n        \"],[10,\"h2\"],[14,0,\"o--blank__title\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"shopify.errors.no_products.title\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,2],[14,0,\"o--blank__desc u--text--light\"],[12],[1,\"\\n          \"],[1,[28,[35,8],[[28,[37,1],[\"shopify.errors.no_products.description\"],null]],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[1,\"      \"],[10,\"ul\"],[14,0,\"u--listUnstyle\"],[12],[1,\"\\n\"],[41,[30,0,[\"showSearchResults\"]],[[[42,[28,[37,10],[[28,[37,10],[[30,0,[\"searchResults\"]]],null]],null],null,[[[1,\"            \"],[8,[39,11],null,[[\"@product\",\"@setProduct\"],[[30,1],[30,2]]],null],[1,\"\\n\"]],[1]],null]],[]],[[[42,[28,[37,10],[[28,[37,10],[[30,0,[\"filteredShopifyProducts\"]]],null]],null],null,[[[1,\"            \"],[8,[39,11],null,[[\"@product\",\"@setProduct\"],[[30,3],[30,2]]],null],[1,\"\\n\"]],[3]],null]],[]]],[41,[30,0,[\"canLoadMore\"]],[[[1,\"          \"],[11,2],[24,0,\"u--text--center u--text--light u--p__t\"],[4,[38,12],null,[[\"onEnter\",\"viewportSpy\"],[[28,[37,13],[[30,0],[30,0,[\"loadMore\"]]],null],true]]],[12],[1,\"\\n            \"],[1,[28,[35,1],[\"shared_words.loading\"],null]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n    \"]],[]]]],[]]]],[]]]],[]]],[1,\"  \"],[13],[1,\"\\n\"],[13]],[\"product\",\"@setProduct\",\"product\"],false,[\"did-insert\",\"t\",\"perfect-scroll\",\"svg-jar\",\"input\",\"perform\",\"if\",\"shared/loading-spinner\",\"html-safe\",\"each\",\"-track-array\",\"shared/linkinbio/item/shopify-product\",\"in-viewport\",\"action\"]]",
    "moduleName": "shared/components/shared/linkinbio/modal/shopify-product-selector.hbs",
    "isStrictMode": false
  });

  let ShopifyProductSelectorComponent = (_class = class ShopifyProductSelectorComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "shopify", _descriptor, this);

      _initializerDefineProperty(this, "isLoading", _descriptor2, this);

      _initializerDefineProperty(this, "searchResults", _descriptor3, this);

      _initializerDefineProperty(this, "shopifyQuery", _descriptor4, this);

      _initializerDefineProperty(this, "selectedVariant", _descriptor5, this);
    }

    get canLoadMore() {
      return this.shopify.hasNextPage;
    }

    get filteredShopifyProducts() {
      return this.shopifyProducts;
    }

    get noProducts() {
      return (0, _utils.isEmpty)(this.shopifyProducts);
    }

    get noSearchResults() {
      return this.searchResults.length === 0 && !this.searchProducts.isRunning && this.shopifyQuery;
    }

    get shopifyProducts() {
      return this.shopify.shopifyProducts;
    }

    get showSearchResults() {
      return this.shopifyQuery && !this.searchProducts.isRunning && this.searchResults.length > 0;
    }

    loadProducts() {
      this.isLoading = true;
      this.shopify.getProducts().catch(this.args.handleShopifyError).finally(() => {
        if (!(this.isDestroyed || this.isDestroying)) {
          this.isLoading = false;
        }
      });
    }

    clearQuery() {
      this.shopifyQuery = '';
      this.shopify.resetSearchResults();
    }

    loadMore() {
      if (this.shopifyQuery) {
        this.shopify.loadMoreProductsQuery();
      } else {
        this.shopify.loadMoreProducts();
      }
    }

    *searchProducts(query) {
      if (!query) {
        this.clearQuery();
        return;
      }

      yield (0, _emberConcurrency.timeout)(500);

      try {
        const searchResults = yield this.shopify.queryProducts(query);
        this.searchResults = searchResults;
      } catch (error) {
        this.args.handleShopifyError(error);
      }
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "shopify", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isLoading", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "searchResults", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return [];
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "shopifyQuery", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "selectedVariant", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "loadProducts", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "loadProducts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearQuery", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "clearQuery"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadMore", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "loadMore"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "searchProducts", [_emberConcurrencyDecorators.restartableTask], Object.getOwnPropertyDescriptor(_class.prototype, "searchProducts"), _class.prototype)), _class);
  _exports.default = ShopifyProductSelectorComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ShopifyProductSelectorComponent);
});